import React from 'react'
import {
  Button,
  Box,
  Container,
} from '@material-ui/core'

interface SelectBrokerProps {
  brokers : Array<string>
  handleSelectBroker : (broker:string)=>void
}

const SelectBrokerSection:React.FC<SelectBrokerProps> = ({
  brokers,
  handleSelectBroker,
}) => {
  return (
  <Container maxWidth="xs">
    {brokers.map((broker) => (
      <Button
        key={`select-${broker}`}
        fullWidth
        variant="contained"
        color="primary"
        onClick={(e) => handleSelectBroker("signInBrokerModal")}
      >
        {broker}
      </Button>
    ))
  }
  <Box mb={1}/>
  </Container>
  )
}

export default SelectBrokerSection